import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Modal from "@mui/material/Modal";
import { addUser, sendOTP, verifyOTP } from "@queries/auth.queries";
import guestModalClasses from "../styles/guestModal.module.css";
import { domain } from "@utils/BASE-URL";
import { trackEvent, trackPeopleAuth, trackUserAttributes } from "@utils/analytics/event-analytics";
import { LANGUAGE, SMS_TEMPLATE, WEB_ENGAGE } from "@utils/constants";
import Image from "next/legacy/image";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import "react-phone-number-input/style.css";
import applogo from "../../../public/logo.webp";
import UtsavTextField from "./UtsavTextField";
import { Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { useTranslation } from "react-i18next";
import Link from "next/link";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import UtsavNewModal from "../views/UtsavNewModal";
import { setUserData } from "@utils/reduxToolkit/features/userSlice";
import { useDispatch } from "react-redux";
import { getEncryptedCookieUserData } from "@utils/cookie/cookies";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import OTPInput from "react-otp-input";
import { useReadOTP } from "react-read-otp";
const GuestPopup = ({
  open,
  setLoginModalOpen,
  handleBlogLoginModal
}) => {
  // Component definition is missing display name

  const {
    t
  } = useTranslation();
  const [tcWatsapp, setTCWatsapp] = useState(true);
  const [name, setName] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [verificationKey, setVerificationKey] = useState("");
  const [, setCookie] = useCookies(["token"]);
  const router = useRouter();
  const dispatch = useDispatch();
  const [otp, setOtp] = useState("");
  useReadOTP(setOtp);
  const [showOtp, setShowOtp] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  const [nameSection, setNameSection] = useState(false);
  const [showRetry, setShowRetry] = useState(false);
  const [timer, setTimer] = useState(30);
  const [otpVerificationSuccess, setOtpVerificationSuccess] = useState(false);
  const [errorModal, setErrorModal] = useState({
    open: false,
    heading: "",
    message: "",
    acceptMethod: () => {},
    icon: null,
    positive: false
  });
  const [accessToken, setAccessToken] = useState("");
  const [data, setData] = useState(null);
  const [contactAdded, setContactAdded] = useState(WEB_ENGAGE.DECISION.YES);
  useEffect(() => {
    let intervalId;
    if (timer > 0) {
      intervalId = setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
      }, 1000);
    } else {
      setShowRetry(true);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [timer]);
  const handleChangeName = e => {
    let value = e.target.value;
    setName(value);
  };
  function handleOnChange(e) {
    let value = e.target.value;
    const digitsOnly = value.replace(/\D/g, "");
    if (digitsOnly.length > 10) return;
    setMobileNo(digitsOnly.slice(-10));
  }
  const isValidPhoneNumber = () => {
    const phoneNumberRegex = /^\d{10}$/;
    return phoneNumberRegex.test(mobileNo.replace(" ", "").replace("-", ""));
  };
  const handleOTPChange = value => {
    // console.log("e", value);
    setOtp(value);
  };
  const handleOnOTPPaste = event => {
    const data = event.clipboardData.getData("text");
    setOtp(data);
  };
  useEffect(() => {
    if (otp.length === 6) {
      verifyOTPHandler(otp);
    }
  }, [otp]);
  async function otpPageFun(e) {
    e.preventDefault();
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN + " " + WEB_ENGAGE.BUTTON_NAMES.GET_OTP + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN,
      [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.GET_OTP
    });
    if (!isValidPhoneNumber()) {
      setErrorModal({
        open: true,
        heading: `${t("info")}`,
        message: `${t("please-enter-10-digits-mobile-no")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <InfoOutlinedIcon sx={{
          fontSize: "3rem",
          color: "orange"
        }} />
      });
      return;
    }
    if (!mobileNo) {
      setErrorModal({
        open: true,
        heading: `${t("info")}`,
        message: `${t("enter-your-mobile-no")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <InfoOutlinedIcon sx={{
          fontSize: "3rem",
          color: "orange"
        }} />
      });
      return () => {};
    }
    if (!tcWatsapp) {
      setErrorModal({
        open: true,
        heading: `${t("info")}`,
        message: `${t("please-agree-to-our-terms-and-conditions")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <InfoOutlinedIcon sx={{
          fontSize: "3rem",
          color: "orange"
        }} />
      });
      return () => {};
    }
    e.target.innerText = `${t("loading")}`;
    const contact = mobileNo.replace(" ", "").replace("-", "");
    const res = await sendOTP({
      contact: contact,
      type: SMS_TEMPLATE.WEBSITE
    });
    if (!res?.success || !res.response?.verificationKey) {
      setErrorModal({
        open: true,
        heading: `${t("error")}`,
        message: `${t("something-went-wrong")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      e.target.innerText = `${t("get-otp")}`;
      return () => {};
    }
    trackPeopleAuth(res.response.data);
    setVerificationKey(res.response.verificationKey);
    setShowOtp(true);
    e.target.innerText = `${t("get-otp")}`;
  }
  const verifyOTPHandler = async otp => {
    const contact = mobileNo.replace(" ", "").replace("-", "");
    const res = await verifyOTP({
      contact: contact,
      verificationKey: verificationKey,
      otp: otp
    });
    // console.log("Verify OTP", res);

    let encryptedUserData = null,
      encryptedUser = null;
    if (!res?.success && res?.message) {
      setErrorModal({
        open: true,
        heading: `${t("error")}`,
        message: res.message,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      return () => {};
    }
    if (!res?.success) {
      setErrorModal({
        open: true,
        heading: `${t("error")}`,
        message: `${t("something-went-wrong-please-try-again")}`,
        acceptMethod: () => {
          setErrorModal({
            ...errorModal,
            open: false
          });
          router.reload();
        },
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      //window.location.reload();
      return () => {};
    }
    setOtpVerificationSuccess(true);
    setAccessToken(res.response?.data?.accessToken);
    const userData = {
      name: res.response?.user?.name,
      uid: res.response?.data?.uid,
      authType: res.response?.data?.authType,
      accessToken: res.response?.data?.accessToken,
      role: res.response?.userRole
    };
    dispatch(setUserData({
      userData: userData,
      lang: res.response?.user?.UserDetail?.language ?? LANGUAGE.ENGLISH
    }));
    setData(res.response?.data);
    const data = {
      type: "phone",
      data: res.response
    };
    const obj = getEncryptedCookieUserData(data.data);
    if (obj) {
      encryptedUser = obj.encryptedUser;
      encryptedUserData = obj.encryptedUserData;
    }
    trackPeopleAuth(res.response.data);
    if (res.isRegistered) {
      try {
        trackUserAttributes(res.response.user);
        trackEvent(WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN + " " + WEB_ENGAGE.EVENT_NAMES.USER_AUTH_SUCCESS, {
          [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN,
          [WEB_ENGAGE.EVENT_PROPERTIES.AUTH_METHOD]: WEB_ENGAGE.AUTH_METHODS.PHONE,
          [WEB_ENGAGE.EVENT_PROPERTIES.USER_TYPE]: WEB_ENGAGE.USER_TYPE.OLD
        });
      } catch (error) {
        alert("error in track user attributes", error);
      }
      setLoginModalOpen(false);
      setShowOtp(false);
      setShowLogin(true);
      setCookie("utsavUser", encryptedUser, {
        path: "/",
        secure: true,
        sameSite: "none",
        domain: domain,
        maxAge: 60 * 60 * 24 * 7 //7-days
      });
      setCookie("utsavData", encryptedUserData, {
        path: "/",
        secure: true,
        sameSite: "none",
        domain: domain,
        maxAge: 60 * 60 * 24 * 7 //7-days
      });
      router.reload();
      return () => {};
    }
    setNameSection(true);
    setShowOtp(false);
    setShowLogin(true);
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN + " " + WEB_ENGAGE.EVENT_NAMES.USER_AUTH_SUCCESS, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN,
      [WEB_ENGAGE.EVENT_PROPERTIES.AUTH_METHOD]: WEB_ENGAGE.AUTH_METHODS.PHONE,
      [WEB_ENGAGE.EVENT_PROPERTIES.USER_TYPE]: WEB_ENGAGE.USER_TYPE.NEW
    });
  };
  async function resendOTPFun(e) {
    e.preventDefault();
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN + +" " + WEB_ENGAGE.TEXT_NAMES.RESEND_OTP + +" " + WEB_ENGAGE.EVENT_NAMES.TEXT_CLICKED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.OTP_ONBOARDING_SCREEN,
      [WEB_ENGAGE.EVENT_PROPERTIES.TEXT_NAME]: WEB_ENGAGE.TEXT_NAMES.RESEND_OTP
    });
    if (!mobileNo) {
      setErrorModal({
        open: true,
        heading: `${t("error")}`,
        message: `${t("enter-your-mobile-no")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      return () => {};
    }
    e.target.innerText = `${t("loading")}`;
    const contact = mobileNo.replace(" ", "").replace("-", "");
    const res = await sendOTP({
      contact: contact
    });
    if (!res?.success || !res.response?.verificationKey) {
      setErrorModal({
        open: true,
        heading: `${t("error")}`,
        message: `${t("something-went-wrong")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <ErrorOutlineOutlinedIcon sx={{
          fontSize: "3rem",
          color: "red"
        }} />
      });
      e.target.innerText = `${t("resend-otp")}`;
      return () => {};
    }
    setVerificationKey(res.response.verificationKey);
    setShowOtp(true);
    setTimer(30);
    setShowRetry(false);
    e.target.innerText = `${t("resend-otp")}`;
    setErrorModal({
      open: true,
      heading: `${t("resend-otp")}`,
      message: `${t("otp-sent-successfully")}`,
      acceptMethod: () => setErrorModal({
        ...errorModal,
        open: false
      }),
      icon: <CheckCircleOutlineOutlinedIcon sx={{
        fontSize: "3rem",
        color: "green"
      }} />,
      positive: true
    });
  }
  const submitHandler = async e => {
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN + " " + WEB_ENGAGE.BUTTON_NAMES.USER_REGISTER + " " + WEB_ENGAGE.EVENT_NAMES.BUTTON_CLICKED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN,
      [WEB_ENGAGE.EVENT_PROPERTIES.BUTTON_NAME]: WEB_ENGAGE.BUTTON_NAMES.USER_REGISTER
    });
    if (e) e.preventDefault();
    if (!name) {
      setErrorModal({
        open: true,
        heading: `${t("info")}`,
        message: `${t("enter-your-name")}`,
        acceptMethod: () => setErrorModal({
          ...errorModal,
          open: false
        }),
        icon: <InfoOutlinedIcon sx={{
          fontSize: "3rem",
          color: "orange"
        }} />
      });
      return () => {};
    }
    //console.log("Regstr");

    const registrationDoc = {
      name: name,
      dp: null,
      UserDetail: {
        contact: mobileNo,
        email: null,
        whatsappEnabled: tcWatsapp
      },
      UserAddress: {},
      UserMetric: {},
      UserReferral: {},
      communityIDs: []
    };
    const createdUser = await addUser({
      data: registrationDoc,
      accessToken
    });
    if (createdUser) {
      let authType;

      // if (token.type === "phone") {
      authType = WEB_ENGAGE.AUTH_METHODS.PHONE;
      // } else {
      //   authType = WEB_ENGAGE.AUTH_METHODS.GOOGLE;
      // }
      const token = {
        type: "phone",
        data: {
          user: null
        }
      };
      if (token.type === "phone") {
        const newToken = token;
        newToken.data.data = data;
        newToken.data.user = createdUser;
        let encryptedUserData = null,
          encryptedUser = null;
        const obj = getEncryptedCookieUserData(newToken.data);
        if (obj) {
          encryptedUser = obj.encryptedUser;
          encryptedUserData = obj.encryptedUserData;
        }
        // setCookie("token", newToken, {
        //   maxAge: 300,
        //   secure: true,
        //   domain: domain,
        // });
        setCookie("utsavUser", encryptedUser, {
          path: "/",
          secure: true,
          sameSite: "none",
          domain: domain,
          maxAge: 60 * 60 * 24 * 7 //7-days
        });
        setCookie("utsavData", encryptedUserData, {
          path: "/",
          secure: true,
          sameSite: "none",
          domain: domain,
          maxAge: 60 * 60 * 24 * 7 //7-days
        });
        setCookie("newUser", true, {
          maxAge: 60 * 60 * 24 * 7,
          //7-days
          secure: true,
          domain: domain
        });
      }
      try {
        trackUserAttributes(createdUser);
      } catch (error) {
        alert("error in track user attributes", error);
      }
      trackEvent(WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN + " " + WEB_ENGAGE.EVENT_NAMES.USER_REGISTRATION_SUCCESS, {
        [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.CREATE_PROFILE,
        [WEB_ENGAGE.EVENT_PROPERTIES.AUTH_METHOD]: authType,
        [WEB_ENGAGE.EVENT_PROPERTIES.CONTACT_ADDED]: contactAdded
      });
      setLoginModalOpen(false);
      // setTimeout(() => {
      //   router.reload();
      // }, 3000);
      router.reload();
    } else {
      alert(`${t("something-went-wrong")}`);
    }
  };
  return <>
      {open && <Modal open={open} onClose={() => setLoginModalOpen(false)}>
          <div className={guestModalClasses.modalOver}>
            <div className={guestModalClasses.modalCard}>
              <div className={guestModalClasses.utsavLogo}>
                <div className={`${guestModalClasses.section5_box_header_logobox}`}>
                  {!showOtp && <Image src={applogo} alt="Utsav Logo" className={`${guestModalClasses.section5_box_header_logobox_img}`} width="35" height="35" />}
                  {showOtp && <div onClick={() => {
                setShowOtp(false);
              }}>
                      <ArrowBackIcon />
                    </div>}
                </div>
                <div className={`${guestModalClasses.section5_box_header_detbox}`}>
                  <div className={`${guestModalClasses.section5_box_header_detbox_head}`}>
                    {t("login")}
                  </div>
                </div>
                {handleBlogLoginModal && <div style={{
              marginLeft: "auto",
              backgroundColor: "#eeeeee",
              padding: "5px 15px",
              borderRadius: "15px"
            }} onClick={() => handleBlogLoginModal(false)}>
                    {" "}
                    {/* <KeyboardArrowDownIcon />{" "} */}
                    <Typography sx={{
                fontSize: "14px"
              }}>
                      {t("skip")}
                    </Typography>
                  </div>}
              </div>
              {showLogin && !showOtp && !nameSection && <>
                  <div className={guestModalClasses.mRestBx}>
                    <div className={guestModalClasses.iRestBx}>
                      <span className={guestModalClasses.onboardingHeader}>
                        {t("enter-your-phone-number")}
                      </span>
                      <UtsavTextField label={t("enter-phone-number")} type="tel" value={mobileNo} autoComplete="tel" inputProps={{
                  inputMode: "numeric",
                  pattern: "[0-9]*"
                }} setProps={handleOnChange} startAdornment={"+91"} />
                      <div className={guestModalClasses.whatsappUpdate}>
                        <Checkbox checked={tcWatsapp} onClick={() => {
                    if (tcWatsapp) {
                      trackEvent(WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN + " " + WEB_ENGAGE.EVENT_NAMES.BOX_CHECKED, {
                        [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN,
                        [WEB_ENGAGE.EVENT_PROPERTIES.CHECK_STATUS]: WEB_ENGAGE.DECISION.YES
                      });
                    } else {
                      trackEvent(WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN + " " + WEB_ENGAGE.EVENT_NAMES.BOX_CHECKED, {
                        [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN,
                        [WEB_ENGAGE.EVENT_PROPERTIES.CHECK_STATUS]: WEB_ENGAGE.DECISION.NO
                      });
                    }
                    setTCWatsapp(prev => !prev);
                  }} className={guestModalClasses.tcIcon_1} sx={{
                    color: "#27ae60",
                    "&.Mui-checked": {
                      color: "#27ae60"
                    },
                    marginLeft: "-7px"
                    // marginTop: "-15px",
                  }} />
                        <Typography className={guestModalClasses.tcIcon_2}>
                          {t("send-puja-updates-on-whatsapp")}
                        </Typography>
                      </div>
                      <button className={guestModalClasses.gOtpButton}
                //  ${
                //   tcPolicy && tcWatsapp ? "" : classes.btn_disabled
                // }`
                onClick={otpPageFun}
                // disabled={!tcWatsapp}
                >
                        {t("get-otp")}
                      </button>
                    </div>
                  </div>

                  <span className={guestModalClasses.t_cDiv}>
                    <p className={guestModalClasses.tctext}>
                      {t("by-continuing-you-agree-to-our")}{" "}
                      <Link href={"/terms-of-use"} target="_blank" rel="alternate" hrefLang={router.locale}>
                        <span
                  // onClick={() => window.open("/terms-of-use", "_blank")}
                  style={{
                    cursor: "pointer",
                    color: "#ff9800"
                  }}>
                          {t("terms-of-service")}
                        </span>
                      </Link>{" "}
                      {t("and")}{" "}
                      <Link href={"/privacy-and-cookie-policy"} target="_blank" rel="alternate" hrefLang={router.locale}>
                        <span
                  // onClick={() => window.open("/content-policy", "_blank")}
                  style={{
                    cursor: "pointer",
                    color: "#ff9800"
                  }}>
                          {t("privacy-policy")}
                        </span>
                      </Link>
                    </p>
                  </span>
                </>}

              {showOtp && !nameSection && <>
                  <div className={guestModalClasses.mRestBx}>
                    <div className={guestModalClasses.onboardingHeader}>
                      {t("otp-verification")}
                    </div>
                    <OTPInput value={otp} onChange={handleOTPChange} onPaste={handleOnOTPPaste} inputType="number" numInputs={6} renderSeparator={<span> </span>} renderInput={props => <input {...props} />} inputStyle={guestModalClasses.otpBox1} containerStyle={{
                justifyContent: "space-between",
                alignItems: "center"
              }} />{" "}
                    {showRetry ? <div onClick={() => {
                trackEvent(WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN + " " + WEB_ENGAGE.TEXT_NAMES.CHANGE_NUMBER + " " + WEB_ENGAGE.EVENT_NAMES.TEXT_CLICKED, {
                  [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.BLOG_ONBOARDING_SCREEN,
                  [WEB_ENGAGE.EVENT_PROPERTIES.TEXT_NAME]: WEB_ENGAGE.TEXT_NAMES.RESEND_OTP
                });
                // resendOTPHandler();
              }} className={guestModalClasses.otpBxEx}>
                        <span
                // className={classes.resendOTP}
                onClick={resendOTPFun}>
                          {t("resend-otp-0")}
                        </span>
                      </div> : <div className={guestModalClasses.otpBxEx}>
                        {t("didn-and-apos-t-receive-the-otp")}{" "}
                        <span style={{
                  color: "#323232",
                  fontWeight: "600"
                }}>
                          {t("retry-in")} {timer > 0 ? timer : 0} s
                        </span>
                      </div>}
                    {/* <div>
                     <button
                      className={`${guestModalClasses.gOtpButton} ${
                        otpVerificationSuccess
                          ? ""
                          : guestModalClasses.btn_disabled
                      }`}
                      onClick={() => {
                        if (otpVerificationSuccess) {
                          // setNameSection(true);
                          // setShowOtp(false);
                          // setShowLogin(true);
                        }
                      }}
                      disabled={!otpVerificationSuccess}
                     >
                      {t("continue")}
                     </button>
                     </div> */}
                  </div>
                </>}

              {nameSection && !showOtp && <div className={guestModalClasses.NameSection}>
                  <div className={guestModalClasses.onboardingHeader}>
                    {t("enter-your-name")}
                  </div>
                  <div>
                    {" "}
                    <UtsavTextField type="text" value={name} autoComplete="none" label={t("enter-your-name")} setProps={handleChangeName} />
                  </div>
                  <button type="submit" className={guestModalClasses.gOtpButton} onClick={e => {
              submitHandler(e);
            }}>
                    {t("continue")}
                  </button>
                </div>}
            </div>
          </div>
        </Modal>}
      {errorModal.open && <UtsavNewModal open={errorModal.open} toggleModal={() => setErrorModal(prevState => ({
      ...prevState,
      open: true
    }))} heading={errorModal.heading} message={errorModal.message} acceptMsg={t("okay")} onAccept={errorModal.acceptMethod}
    // rejectMsg="Cancel"
    icon={errorModal.icon} positive={errorModal.positive} />}
    </>;
};
export default GuestPopup;